import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js';
import React, { useEffect, useState } from 'react'
import CustomButton from '../../Components/CustomButton';
import { useNavigate } from 'react-router';
import { Modal } from 'react-bootstrap';
import BASEURL from '../../Config/global';
import axios from 'axios';
import PaymentDeclined from '../../Components/PaymentDeclined';
import { useSelector } from 'react-redux';
import { removeAccessToken } from '../../Util/authHeader';
import CustomInput from '../../Components/CustomInput';
import { logo } from '../../Assets/images';

const PaymentScreen = () => {

    const user = JSON.parse(localStorage.getItem("user"));
    const userPrompts = useSelector((state) => state.user.userPrompts);

    const [couponDetail, setCouponDetail] = useState();
    const [loading, setLoading] = useState(false);
    const [couponPaymentError, setCouponPaymentError] = useState({ error: false, text: "" });
    const [paymentDecline, setPaymentDecline] = useState(false);
    const [couponError, setCouponError] = useState({ error: false, text: "" });
    const [succesModal, setSuccesModal] = useState(false);
    const [couponCodeModal, setCouponCodeModal] = useState({
        show_modal: false,
        code: '',
        error_msg: '',
        error: false,
        loading: false
    });
    const [fullPageloading, setFullPageloading] = useState(true);


    const navigate = useNavigate();
    const stripe = useStripe()
    const [couponData, setCouponData] = useState([]);

    const elements = useElements()

    useEffect(() => {

        if (user?.coupon && user?.coupon?.id) {
            getCouponDataByApi(user?.coupon?.id)
        } else {
            setCouponCodeModal({
                ...couponCodeModal,
                show_modal: true
            })
            setFullPageloading(false);
        }
        return () => {
            sessionStorage.clear();
        };
    }, [])

    const getCouponDataByApi = async (id, status) => {
        setFullPageloading(true);
        try {
            const response = await axios.get(`${BASEURL}/api/user/get_coupon?coupon_id=${id}`);
            if (!response.data.error) {
                setCouponData(response.data.data[0]);
                setCouponDetail(response.data.data[0].coupon_detail[0]);
                setFullPageloading(false);
            } else {
                setFullPageloading(false);
            }
        } catch (error) {
            console.error('Error:', error);
            setCouponError({ error: true, text: "Promo invalid" });
            setFullPageloading(false);
        }
    }

    async function signUpAPi() {
        setLoading(true);
        setCouponPaymentError({ error: false, text: "" });
        try {
            if (!stripe || !elements) {
                return;
            }
            const cardElement = elements.getElement(CardElement);

            if (!cardElement) {
                console.error("CardElement is not mounted");
                return;
            }

            const { paymentMethod, error } = await stripe.createPaymentMethod({
                type: 'card',
                card: cardElement,
            });

            if (error) {
                setLoading(false);
                if (error.message.includes('Invalid API Key provided:')) {
                    setCouponPaymentError({ error: true, text: userPrompts?.invalid_card_details || 'Invalid Card Details' });
                } else {
                    setCouponPaymentError({ error: true, text: userPrompts?.invalid_card_details || 'Invalid Card Details' });
                    // setCouponPaymentError({ error: true, text: error.message });
                    console.error(error.message);
                    setPaymentDecline(true);
                    setTimeout(() => {
                        setPaymentDecline(false);
                    }, 2500);
                }
                // setCouponPaymentError({ error: true, text: error.message });
            } else {
                debugger
                let parseData = JSON.parse(localStorage.getItem("user"));
                const userEmail = parseData.email;
                const { propagation_trial_period, subscription_user_propagate, coupon_detail } = couponData
                const planId = subscription_user_propagate ? couponData?.propagation_plan_id : couponData?.plan_id;
                // const trial_period = couponDetail?.trial_period;
                const formData = new FormData();
                formData.append('email', userEmail);
                formData.append('plan_id', planId);
                if (couponData.propagation_duration_type === 'trial_period' && Number(couponData.propagation_trial_period) > 0) {
                    formData.append('trial_period', couponData.propagation_trial_period);
                }
                else if (couponData.propagation_duration_type === 'term_in_days' && Number(couponData.propagation_term_in_days) > 0) {
                    formData.append('trial_period', couponData.propagation_term_in_days);
                }
                formData.append('platform', "web");
                formData.append('paymentMethodId', paymentMethod.id);
                formData.append('coupon_code', 'coupon');
                let send_code;
                if (couponData?.coupon_detail?.length > 0) {
                    const { code, propagation_code } = couponData?.coupon_detail[0]
                    send_code = code || propagation_code;
                }
                formData.append('coupon_code_id', send_code);


                const response = await axios.post(`${BASEURL}/api/user/customersubscription/`, formData);
                // const customerId = response?.data?.data?.customer_id;
                if (!response.data.error) {
                    const productId = couponData['id'];
                    PackageDoneApi(productId);
                } else {
                    setLoading(false);
                    setCouponPaymentError({ error: true, text: userPrompts?.invalid_card_details || 'Invalid Card Details' });
                }
            }
        } catch (error) {
            console.error('Error:', error);
            // Handle the error appropriately, e.g., display an error message to the user.
        }
    }

    const handleLogout = () => {
        removeAccessToken();
        localStorage.removeItem("user");
        localStorage.removeItem("is_primary");
        localStorage.removeItem("user_email");
        localStorage.removeItem("ip");
        localStorage.removeItem("userId");
        window.location.reload(false);
    };

    const submitCouponCode = async () => {

        const userEmail = user.email;
        const code = couponCodeModal.code || '';

        if (code == '' && !code) {
            setCouponCodeModal({
                ...couponCodeModal,
                error: true,
                error_msg: "Please enter code.",
            });
            return;
        }

        try {
            setCouponCodeModal({
                ...couponCodeModal,
                loading: true,
            });
            const response = await axios.post(
                `${BASEURL}/api/user/get_coupon`,
                {
                    "email": userEmail,
                    "code": code
                }
            );
            if (!response.data.error && response?.data?.data?.length > 0) {
                const [result] = response.data.data;
                setCouponData(result);
                setCouponDetail(result?.coupon_detail[0]);
                if (result.price === "0" || result.price === "0.00" || result.price === "0.0") {
                    const productId = result['id'];
                    PackageDoneApi(productId);
                } else {
                    setCouponCodeModal({
                        ...couponCodeModal,
                        show_modal: false,
                        loading: false,
                    });
                }
            } else {
                setCouponCodeModal({
                    ...couponCodeModal,
                    error: true,
                    error_msg: 'coupon invalid'
                });
            }
        } catch (error) {
            setCouponCodeModal({
                ...couponCodeModal,
                loading: false,
                error: true,
                error_msg: 'coupon invalid'
            });
            // console.error('Error:', error);
        }
    }

    const PackageDoneApi = async (productId) => {

        try {

            const user_id = user?.id;
            const product_id = productId;

            const formDataToSend = new FormData();
            formDataToSend.append("user_id", user_id);
            formDataToSend.append("package_id", product_id);

            const response = await axios.post(
                `${BASEURL}/api/user/package_done`,
                formDataToSend
            );

            if (!response.data.error) {
                setCouponCodeModal({
                    ...couponCodeModal,
                    show_modal: false,
                    loading: false
                })
                setLoading(false);
                setSuccesModal(true);
                setTimeout(() => {
                    handleLogout();
                }, 1500);
            }

        } catch (error) {
            console.error(error);
        }
    }

    if (fullPageloading) {
        return (
            <div className='d-flex justify-content-center align-items-center' style={{ height: '100vh' }} >
                <div className="spinner-border" role="status"></div>
            </div>
        )
    }

    return (
        <div>

            <section className='mainPremium'>
                <div className={`container-fluid ${couponCodeModal.show_modal || succesModal ? 'd-none' : ''}`}>
                    <div className='coupon-payment-wrapper p-4 text-center'>
                        <p className='lightColor fs-6 mb-2'>Enter Payment Method</p>
                        <h2 className="pageTitle mb-2">{couponDetail?.title}</h2>
                        {/* <p className='lightColor fs-5 mb-2'>{couponDetail?.description} (Free 14 Day Trial)</p> */}
                        <p className='lightColor fs-5 mb-2'>{couponDetail?.description}</p>
                        {/* {
                            couponDetail?.duration_type === 'term_in_days' ?
                                <p className='lightColor fs-6 mb-2'>Term in days: {couponDetail?.term_in_days} Days </p>
                                :
                                <p className='lightColor fs-6 mb-2'>Free Trial Period: {couponDetail?.trial_period} Days </p>
                        } */}
                        <p className='lightColor fs-6 mb-2'>Payment Type: <span className='text-capitalize'>{`${couponDetail?.subscription_type}ly`}</span></p>
                        <p className='lightColor fs-6 mb-2 '>Price : ${couponDetail?.price} USD</p>
                        <div className='cardBox my-4'>
                            <CardElement />
                        </div>
                        {
                            couponPaymentError.error && <p className='my-2 text-danger'>{couponPaymentError.text}</p>
                        }
                        {
                            loading ? (
                                <div className='payNow text-center mt-4'>
                                    <button className="primaryButton customButton">
                                        <div className="spinner-border spinner-border-sm text-dark" role="status"></div>
                                    </button>
                                </div>
                            )
                                : (
                                    <div className='d-flex justify-content-center align-items-center gap-4  w-100'>
                                        <div className='payNow text-center mt-4'>
                                            <CustomButton
                                                variant="primaryButton"
                                                text="Save"
                                                onClick={signUpAPi}
                                            />

                                        </div>
                                        <div className='payNow text-center mt-4 '>
                                            <CustomButton
                                                variant="primaryButton"
                                                text="Cancel"
                                                onClick={() => navigate("/home")}
                                            />
                                        </div>
                                    </div>
                                )
                        }
                    </div>
                </div>
            </section >

            <PaymentDeclined paymentDecline={paymentDecline} />

            <Modal
                show={couponCodeModal.show_modal}
                centered
                className="coupon-modal"
                backdrop="static"
            >
                <Modal.Body>
                    <div className='py-5'>
                        <img src={logo} alt="Logo" className='logo' />
                        <div className='field-wrapper mt-5'>
                            <CustomInput
                                placeholder={''}
                                id="coupon"
                                type="text"
                                labelClass="mainLabel"
                                inputClass="mainInput text-center"
                                label="Promo Code"
                                onChange={(event) => {
                                    setCouponCodeModal({
                                        ...couponCodeModal,
                                        error: false,
                                        error_msg: "",
                                        code: event.target.value,
                                    });
                                }}
                            />
                        </div>
                        <div className='d-flex justify-content-center flex-column align-items-center gap-2 mt-1'>
                            {couponCodeModal.error && (
                                <p className="smallText lightColor text-center mb-0">{couponCodeModal.error_msg}</p>
                            )}
                            <div className='payNow text-center mt-4'>
                                {
                                    couponCodeModal?.loading ?
                                        <div className='payNow text-center'>
                                            <button className="primaryButton customButton">
                                                <div className="spinner-border spinner-border-sm text-dark" role="status"></div>
                                            </button>
                                        </div>
                                        :
                                        <CustomButton
                                            variant="primaryButton"
                                            text={"Submit"}
                                            onClick={submitCouponCode}
                                        />
                                }
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal
                show={succesModal}
                centered
                className="success-modal"
                backdrop="static"
            >
                <Modal.Body>
                    <div className="p-5">
                        <h2 className="font-16 lh-16 my-5 fw-normal text-center">{couponDetail?.duration_type === "term_in_days" ? userPrompts?.payment_paid_successfully_message || 'Paid Successfully' : userPrompts?.payment_saved_successfully_message || 'Saved Successfully'}</h2>
                    </div>
                </Modal.Body>
            </Modal>

        </div>
    )
}

export default PaymentScreen